<div class="login-wrapper">
  <div class="left">
    <img *ngIf="login.logo" [src]="login.logo | safe" />
    <span class="text" [innerHtml]="login.text | safeHTML"></span>
    <span class="headline" [innerHtml]="login.title | safeHTML"></span>
    <form class="marginTop" (submit)="onLogin(ticketcodeForm)" #ticketcodeForm="ngForm" *ngIf="!isLoading" data-private>
      <div *ngIf="invalid && !isLoading" class="invalid" [innerHtml]="login.errorInvalid | safeHTML"></div>
      <div *ngIf="notActivated && !isLoading" class="invalid">Sie müssen Ihre Email erst bestätigen.</div>
      <span *ngIf="login.type === 1" class="label" [innerHtml]="login.placeholderEmail"></span>
      <mat-form-field *ngIf="login.type === 1" appearance="outline" color="accent">
        <input
          matInput
          name="email"
          ngModel
          type="email"
          pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,40}$"
          placeholder="{{ login.placeholderEmail }}"
          #emailInput="ngModel"
          required
        />
        <mat-error *ngIf="emailInput.invalid" [innerHtml]="login.errorEmail | safeHTML"></mat-error>
      </mat-form-field>
      <span class="label" [innerHtml]="login.placeholderTicketcode"></span>
      <mat-form-field *ngIf="login.type !== 1" appearance="outline" color="accent">
        <input
          matInput
          name="ticketcode"
          ngModel
          type="text"
          placeholder="{{ login.placeholderTicketcode }}"
          #ticketcodeInput="ngModel"
          required
        />
        <mat-error *ngIf="ticketcodeInput.invalid" [innerHtml]="login.errorTicketcode | safeHTML"></mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="login.type === 1" appearance="outline" color="accent">
        <input
          matInput
          name="ticketcode"
          ngModel
          [type]="hidePw ? 'password' : 'text'"
          placeholder="{{ login.placeholderTicketcode }}"
          #passwordInput="ngModel"
          required
        />
        <span
          class="hidePwButton"
          mat-icon-button
          matSuffix
          (click)="hidePw = !hidePw"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hidePw"
        >
          <mat-icon>{{ hidePw ? 'visibility' : 'visibility_off' }}</mat-icon>
        </span>
        <mat-error *ngIf="passwordInput.invalid" [innerHtml]="login.errorTicketcode | safeHTML"></mat-error>
      </mat-form-field>
      <span *ngIf="login.type === 1" class="fogotPw" [innerHtml]="login.forgotPw" (click)="onForgotPassword()"></span>
      <button class="loginButton" mat-flat-button color="primary" type="submit">{{ login.buttonText }}</button>
    </form>
    <div class="row marginTop" *ngIf="enabledEmail || registrationOn">
      <span class="registerText" [innerHtml]="login.notRegisteredText | safeHTML"></span>
      <a class="questionButton" [routerLink]="['../register']">{{ login.toRegistrationText }}</a>
    </div>
    <div class="supportButton" *ngIf="login.showSupport">
      <button mat-icon-button (click)="openSupport()">
        <mat-icon>help</mat-icon>
      </button>
    </div>
  </div>
  <div class="image-div" *ngIf="login.keyvisual">
    <img [src]="login.keyvisual | safe" />
  </div>
  <div class="right" *ngIf="!login.keyvisual"></div>
</div>
